import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0ea490d0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "pageBox layoutBox" }
const _hoisted_2 = /*#__PURE__*/_createTextVNode("意见反馈")
const _hoisted_3 = /*#__PURE__*/_createTextVNode("提交")
const _hoisted_4 = { class: "page_main" }
const _hoisted_5 = /*#__PURE__*/_createTextVNode("提 交")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_NavBox = _resolveComponent("NavBox")!
  const _component_el_breadcrumb_item = _resolveComponent("el-breadcrumb-item")!
  const _component_el_breadcrumb = _resolveComponent("el-breadcrumb")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_ImagesUpload = _resolveComponent("ImagesUpload")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_form = _resolveComponent("el-form")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_NavBox, {
      selectedItem: _ctx.selectedItem,
      "onUpdate:selectedItem": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.selectedItem) = $event))
    }, null, 8, ["selectedItem"]),
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_el_breadcrumb, { "separator-icon": "arrow-right-bold" }, {
        default: _withCtx(() => [
          _createVNode(_component_el_breadcrumb_item, null, {
            default: _withCtx(() => [
              _hoisted_2
            ]),
            _: 1
          }),
          _createVNode(_component_el_breadcrumb_item, null, {
            default: _withCtx(() => [
              _hoisted_3
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_el_form, {
          class: "addForm",
          model: _ctx.addOrEditForm,
          rules: _ctx.addOrEditRules,
          ref: "addOrEditFormRef",
          "label-width": "auto",
          "label-position": "top"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form_item, {
              label: "主题：",
              prop: "title",
              style: {"width":"100%"}
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: _ctx.addOrEditForm.title,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.addOrEditForm.title) = $event)),
                  placeholder: "请输入主题",
                  clearable: ""
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "意见或建议：",
              prop: "content",
              style: {"width":"100%"}
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: _ctx.addOrEditForm.content,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.addOrEditForm.content) = $event)),
                  placeholder: "请输入意见或建议",
                  type: "textarea",
                  rows: 6,
                  clearable: ""
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "图片（选填，提供问题的截图）",
              prop: "pic",
              style: {"width":"100%"}
            }, {
              default: _withCtx(() => [
                _createVNode(_component_ImagesUpload, {
                  urlList: _ctx.addOrEditForm.pic,
                  "onUpdate:urlList": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.addOrEditForm.pic) = $event)),
                  width: 150,
                  height: 150,
                  notip: "",
                  max: 6
                }, null, 8, ["urlList"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "联系人：",
              prop: "name"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: _ctx.addOrEditForm.name,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.addOrEditForm.name) = $event)),
                  placeholder: "请输入联系人",
                  clearable: "",
                  disabled: ""
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "联系方式：",
              prop: "mobile"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: _ctx.addOrEditForm.mobile,
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.addOrEditForm.mobile) = $event)),
                  placeholder: "请输入联系方式",
                  clearable: "",
                  disabled: ""
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, { style: {"width":"100%","text-align":"center","margin-top":"50px"} }, {
              default: _withCtx(() => [
                _createVNode(_component_el_button, {
                  type: "primary",
                  onClick: _ctx.onSubmit
                }, {
                  default: _withCtx(() => [
                    _hoisted_5
                  ]),
                  _: 1
                }, 8, ["onClick"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["model", "rules"])
      ])
    ])
  ]))
}